export const GET_LIST_DANHSACHCHINHANH = "GET_LIST_DANHSACHCHINHANH";
export const GET_LIST_DANHSACHCHINHANH_SUCCESS =
  "GET_LIST_DANHSACHCHINHANH_SUCCESS";
export const GET_LIST_DANHSACHCHINHANH_FAILURE =
  "GET_LIST_DANHSACHCHINHANH_FAILURE";

export const UPDATE_SEARCHTDATA_DANHSACHCHINHANH =
  "UPDATE_SEARCHTDATA_DANHSACHCHINHANH";
